import { Gsc } from "vmi-gsc";
import { Color } from "three";
import { useGLTF } from "@common/hooks/useGLTF";
import UnitOverlayGeometry from "@common/components/UnitOverlays";
import { Selector } from "./TheLocation";

const Residences = ({
  center,
  pathname,
  selectedUnit,
  filteredUnits,
  onSelectedUnitChange,
  handleClickMesh,
  splatDataOnLoad,
  recordMode,
  renderSplat = true,
}) => {
  return (
    <group visible={pathname === "/residences"}>
      {renderSplat && (
        <Gsc
          onLoaded={() => {
            splatDataOnLoad("residences");
          }}
          src="assets/splats/building_2.splat"
        />
      )}

      {!recordMode && <Footprints />}

      {!recordMode && pathname === "/residences" && filteredUnits && (
        <group scale={0.0001}>
          <Compass />

          <UnitOverlayGeometry
            opacity={0.5}
            colours={{
              on: new Color("#DAD6C1"),
              off: new Color("#BA9999"),
            }}
            onSelectedUnitChange={onSelectedUnitChange}
            handleClickMesh={handleClickMesh}
            data={selectedUnit?.[0]
              ? filteredUnits.map((unit) => {
                const newUnit = {
                  ...unit,
                  active: unit.id === selectedUnit[0].id,
                };

                return newUnit;
              })
              : filteredUnits}
            selectedUnit={selectedUnit?.[0]}
            glbSrc="assets/models/proto.glb"
          />
        </group>
      )}
    </group>
  );
};

const Footprints = () => {
  const { nodes } = useGLTF("assets/models/footprint.glb");
  return (
    <mesh
      geometry={nodes["mesh_0"].geometry}
      position={[0, 0, 0]}
      scale={0.0001}
      renderOrder={100}
    >
      <meshBasicMaterial
        depthTest={true}
        depthWrite={true}
        color="#453D35"
      />
    </mesh>
  );
};
const Compass = () => {
  const { nodes } = useGLTF("assets/models/compass.glb");

  return (
    <group rotation-y={0.4} position={[-2600, 0, 0]}>
      <mesh geometry={nodes["mesh_0"].geometry}>
        <meshBasicMaterial color="#79776d" transparent={true} opacity={0.5} />
      </mesh>
    </group>
  );
};
export default Residences;
